import JSEncrypt from 'jsencrypt'
import { Base64 } from 'js-base64'

export default {
  getHomeUrl: function() {
    return process.env.VUE_APP_HOME_API_BASE_URL || 'http://localhost/new-fiss/fiss:8080'
  },
  getAuthenUrl: function (path) {
    const AUTH_BASE_URL = process.env.VUE_APP_AUTHENICATION_API_BASE_URL || 'http://localhost/new-fiss/authen-api-v2'
    const url = AUTH_BASE_URL + path

    return url
  },
  getMemberUrl: function (path) {
    const MEMBER_BASE_URL = process.env.VUE_APP_MEMBER_API_BASE_URL || 'http://localhost/new-fiss/members-api-v2'
    const url = MEMBER_BASE_URL + path

    return url
  },
  getSlime4MemberUrl201: function (path) {
    const MEMBER_BASE_URL = process.env.VUE_APP_MEMBER_API_v2_01_BASE_URL || 'http://localhost/slim4-projects/members-api-v2-01'
    const url = MEMBER_BASE_URL + path

    return url
  },
  getNotificationUrl: function (path) {
    const NOTICE_BASE_URL = process.env.VUE_APP_NOTIFICATION_API_BASE_URL || 'http://localhost:8003'
    const url = NOTICE_BASE_URL + path

    return url
  },
  getPaymentUrl: function (path) {
    const PAYMENT_BASE_URL = process.env.VUE_APP_PAYMENT_API_BASE_URL || 'http://localhost:8101/b-aut'
    const url = PAYMENT_BASE_URL + path

    return url
  },
  getCertificateUrl: function (path) {
    const CERTIFICATE_BASE_URL = process.env.VUE_APP_CERTIFICATE_API_BASE_URL || 'http://localhost:8102/b-aut'
    const url = CERTIFICATE_BASE_URL + path

    return url
  },
  getTonnageReportUrl: function (path) {
    const TONNAGE_BASE_URL = process.env.VUE_APP_TONNAGEREPORT_API_BASE_URL || 'http://localhost:8004'
    const url = TONNAGE_BASE_URL + path

    return url
  },
  postFetch: function (url,params) {
    return this.makeRequest(url,'POST',params)
  },
  postFetchWithToken: function (url,params,token) {
    return this.makeRequest(url,'POST',params,token,'Basic')
  },
  postFetchWithJWT: function (url,params,token,tokenType) {
    return this.makeRequest(url,'POST',params,token,'Bearer')
  },

  makeRequest: function (url, method, params = {},token,tokenType) {
    const responseValue = {
      status: '',
      message: '',
      data: {}
    }

    const options = {
      headers: { 'Content-Type': 'application/json' ,
        'Accept': 'application/json' }
    }

    if ( token !== 'undefined' ) {
      if (tokenType === 'Basic') {
        options.headers = { 
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Basic ' + token
        }
      } else {
        options.headers = { 
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      }
      
    } 
    
    if (method === 'GET') {
      options.method = 'GET'
      if (params !== null)
        url += '?' + (new URLSearchParams(params)).toString()
    }

    if (method === 'POST') {
      options.body = JSON.stringify(params)
      options.method = 'POST'
    }

    return fetch(url, options)
      .then(async (response) => {
        const data = await response.json()

        //console.log('this is our response', response)

        //console.log('this is our data', data)

        responseValue['status'] = response.status
        if (data.message !== undefined) {
          responseValue['message'] = data.message
        }
        if (data.data !== undefined) {
          responseValue['data'] = data.data
        }
        //responseValue['data'] = data.data

        //console.log('our response is ', responseValue)
        return responseValue
      })
      .catch((error) => {
        //console.log(error)
        //console.error(JSON.parse(error))
        if (error instanceof SyntaxError) {
          // Unexpected token < in JSON
          console.log('There was a SyntaxError', error.message)
        } else {
          console.log('There was an error', error)
        }
        /*console.error(JSON.parse(error))
        responseValue['status'] = error.status
        responseValue['message'] = error
        responseValue['data'] = error*/

        //return responseValue

        return error
      })
  },
  makeRemitaRequest: function (url, method, params = {},token,tokenType) {
    const responseValue = {
      status: '',
      message: '',
      data: {}
    }

    const options = {
      headers: { 'Content-Type': 'application/json' ,
        'Accept': 'application/json' }
    }

    if ( token !== 'undefined' ) {
      if (tokenType === 'Basic') {
        options.headers = { 
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Basic ' + token
        }
      } else {
        options.headers = { 
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      }
      
    } 
    
    if (method === 'GET') {
      options.method = 'GET'
      if (params !== null)
        url += '?' + (new URLSearchParams(params)).toString()
    }

    if (method === 'POST') {
      options.body = JSON.stringify(params)
      options.method = 'POST'
    }

    return fetch(url, options)
      .then(async (response) => {
        const data = await response.json()

        console.log('this is our response', response)

        responseValue['status'] = response.status
        responseValue['message'] = response.message
           
        responseValue['data'] = {
          'status': response.message,
          'rrr': response.rrr,
          'billerName': response.billerName,
          'channel': response.channel,  
          'amount': response.amount,
          'chargeFee': response.chargeFee,
          'paymentDate': response.paymentDate,
          'paymentDescription': response.paymentDescription
        }

        return responseValue
      })
      .catch((error) => {
        console.log(error)
        /*if (error instanceof SyntaxError) {
          // Unexpected token < in JSON
          console.log('There was a SyntaxError', error)
        } else {
          console.log('There was an error', error)
        }*/
        console.error(JSON.parse(error))
        responseValue['status'] = error.status
        responseValue['message'] = error
        responseValue['data'] = error

        //return responseValue

        return error
      })
  },
  getPaymentApiToken() {
    // console.log('USERNAME:',process.env.VUE_APP_USERNAME)

    const username = process.env.VUE_APP_USERNAME || 'myADmin_123'
    const password = process.env.VUE_APP_PASSWORD || 'Wer9gyguhijo_123'
    const credentials = `${username}:${password}`
    const encodedCredentials = Base64.encode(credentials)
    const authorizationHeader = encodedCredentials

    return authorizationHeader
  },
  setSessionItem (key, value) {
    localStorage.setItem(key, value)
  },
  setSessionJson (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  getSessionItem (key) {
    return localStorage.getItem(key)
  },
  getSessionJson (key) {
    return JSON.parse(localStorage.getItem(key))
  },
  clearSession() {
    localStorage.clear()
  },
 
  scrollTo(data) {
    if (data === 'top') {
      setTimeout(() => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }, 500)
    }
    if (data === 'bottom') {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}